import { getTemperatureReadingsBySensor } from "./requests";
import { LineChart } from "./charting";
import { UrlHelper, UrlHelperConfiguration } from "./url-helper";
import { LineChartToolbar } from "./line-chart-toolbar";

interface AlertDetailsConfiguration {
    sensorId: number;
    graphStart: string;
    graphEnd: string;
    ids: {
        chartElementId: string;
        chartToolContainerId: string;
    };
    urlHelperConfiguration: UrlHelperConfiguration;
    timeZoneId: string;
}

$(document).on("turbolinks:load", function() {
    const configElement = document.getElementById("alert-details-config");
    if (configElement) {
        const config: AlertDetailsConfiguration = JSON.parse(configElement.innerHTML);
        const page = new AlertDetailsPage(config);
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class AlertDetailsPage {
    private chart: LineChart | undefined;
    private urlHelper: UrlHelper;
    private chartToolbar: LineChartToolbar;

    constructor(private config: AlertDetailsConfiguration) {
        this.urlHelper = new UrlHelper(this.config.urlHelperConfiguration);
        const [defaultFromDate, defaultToDate] = [new Date(this.config.graphStart), new Date(this.config.graphEnd)];
        if (document.getElementById(this.config.ids.chartElementId)) {
            this.chart = new LineChart(
                this.config.ids.chartElementId,
                "focused",
                defaultFromDate,
                defaultToDate,
                (fromDate, toDate) => getTemperatureReadingsBySensor(this.config.sensorId, fromDate, toDate),
                this.urlHelper,
                config.timeZoneId,
            );
    
            this.chartToolbar = new LineChartToolbar(
                $(`#${config.ids.chartToolContainerId}`),
                this.chart,
                "down");
    
            this.chart.firstRender();
        } else {
            // element not present, probably because of subscription/license
        }
    }

    public destroy() {
        this.chart.destroy();
        delete this.chart;

        this.chartToolbar.destroy();
        delete this.chartToolbar;
    }
}